import AfterDoc from '@/components/ui/AfterDoc';
import Button, {
  ButtonLoading,
  ButtonRightArrow,
} from '@/components/ui/Button';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

interface Props {
  onClick: () => void;
  loading: boolean;
}

const ThankYouStageI: React.FC<Props> = ({ onClick, loading }) => {
  const { i18n } = useLingui();

  return (
    <div>
      <AfterDoc
        consultant={CONSULTANTS.EWELINA_ASSISTANT}
        title={i18n.t('Świetna robota!')}
        thankYouMessage={i18n.t('Dokumenty wgrane prawidłowo  👍')}
      >
        <p>
          {i18n.t(
            'Przystąpiliśmy do najbardziej czasochłonnej pracy, jaką jest analiza kosztorysu. Sprawdzimy wiele czynników, które mogły obniżyć Twoje odszkodowanie.'
          )}
        </p>
        <p className="body-semi">
          {i18n.t(
            'Przyspiesz analizę Twojej sprawy aż o 70%, udzielając odpowiedzi na kilka prostych pytań.'
          )}
        </p>
      </AfterDoc>
      <Button
        type="button"
        onClick={onClick}
        loading={loading}
        disabled={loading}
        data-testid="thank-you-stage-i-button-accelerate"
        className={
          'mt-[22px] w-full transition-colors duration-300 md:ml-auto md:w-auto lg:mt-5'
        }
      >
        {i18n.t('Chcę przyspieszyć analizę o 70%')}
        <ButtonLoading />
        <ButtonRightArrow />
      </Button>
    </div>
  );
};

export default ThankYouStageI;
